// @flow

import React from 'react';
import { OrderViewUtils } from 'PMT/utils';

export default function OrderStatusLabel({ status }) {
  return (
    <div
      className={`order_status_label order_status_label__${status} label`}
    >
      {OrderViewUtils.getStatusLabel(status)}
    </div>
  );
}



// WEBPACK FOOTER //
// ./scripts/components/order/OrderStatusLabel.js